<template>
    <pb-body-base>
        <template v-slot:default="props">
            <pb-body banner-size="sm"
                     :banner-logo="category.image"
                     :banner-img="fileResourceUrl(category.bannerImage)"
                     :breadcrumbs="breadcrumbs"
                     :page-title="(category.webName || category.name)">
                <template slot="body">
                    <b-container >

                        <b-nav tabs v-if="category.type != 'CUSTOMER_SHOP'">
                            <b-nav-item active-class="active" :to="{ name: 'customer', params: { id : category.id }}">
                                Articles
                            </b-nav-item>
                            <b-nav-item active-class="active" :to="{ name: 'orders', params: { id : category.id }}">
                                Orders
                            </b-nav-item>
                        </b-nav>
                        <router-view></router-view>

                    </b-container>
                </template>
            </pb-body>
        </template>
    </pb-body-base>
</template>

<script>
import CategoryBase from "@client/src/viewsShop/pages/Category/CategoryBase";
import CategoryApi from "@shared/_api/category";
import Spinner from "@client/src/viewsShop/components/ui/Spinner";

export default {
    name: 'Customer',
    extends: CategoryBase,
    components: {
        'spinner': Spinner
    },
    methods: {
        fetchCategory(id, queryparam) {

            this.busy = true;

            CategoryApi.customerCategoryById(id, queryparam).then(category => {
                this.category = category;
            }).finally(() => {
                this.busy = false;
            });
        },
    }
}
</script>